import { isLocale, replaceUnderscoresWithHyphens } from '@askableorg/i18n';

import type { Locale } from '@askableorg/i18n';

// The clients app reads this cookie at start-up. On production, both apps share it.
const LANG_COOKIE_ATTRIBUTES =
  process.env.NEXT_PUBLIC_CLIENT_URL === 'https://app.askable.com' ? ' domain=.askable.com; SameSite=None; Secure' : '';

/** The API gives a locale with an underscore (`zh_CN`). The i18n resources use a hyphen (`zh-CN`). */
export const toLocale = (value: string | null | undefined): Locale | null => {
  if (!value) {
    return null;
  }

  const locale = replaceUnderscoresWithHyphens(value);

  return isLocale(locale) ? locale : null;
};

/**
 * The language in `?lang=`, read at start-up. The value wins over the profile language, because a
 * caller that gives it knows the language better than the account does. A researcher in preview
 * mode is an example: the account language is not the language of the study.
 */
export const requestedLocale =
  typeof window === 'undefined' ? null : toLocale(new URLSearchParams(window.location.search).get('lang'));

/** Keeps the language for the next page load. `src/i18n` reads this cookie at start-up. */
export const setLangCookie = (locale: Locale) => {
  document.cookie = `lang=${locale}; path=/;${LANG_COOKIE_ATTRIBUTES}`;
};
